import { PickSessionSchema } from "@redotech/redo-fulfillment-wms-common/schema/pick-session";
import { locationIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const getActiveUserPickSessions = {
  name: "getActiveUserPickSessions" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({ pickSessions: z.array(PickSessionSchema) }),
};
